// Updates CSS variable --viewport-bottom-inset so fixed UI can sit above the on-screen keyboard
export default function initViewportInsets() {
    const root = document.documentElement;

    const updateInsets = () => {
        try {
            const vv = window.visualViewport;
            if (vv && typeof vv.height === 'number') {
                const layoutViewportHeight = window.innerHeight;
                const visualViewportBottom = vv.height + (vv.offsetTop || 0);
                const inset = Math.max(0, layoutViewportHeight - visualViewportBottom);
                root.style.setProperty('--viewport-bottom-inset', `${Math.round(inset)}px`);
                return;
            }
        } catch (_) {
            // ignore and fall back below
        }
        // Fallback: no inset information available
        root.style.setProperty('--viewport-bottom-inset', '0px');
    };

    // Initial calculation
    updateInsets();

    // Listen to viewport changes (keyboard open/close triggers these)
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateInsets);
        window.visualViewport.addEventListener('scroll', updateInsets);
    }
    window.addEventListener('resize', updateInsets);
    window.addEventListener('orientationchange', updateInsets);
    document.addEventListener('focusin', updateInsets);
    document.addEventListener('focusout', updateInsets);
}


